import api from "@/api";

const namespaced = true

const state = {
  bargeCostUtilizationData: null,
  routes: [],
  lastRequestId: 0
}

const getters = {
  bargeCostUtilizationData: (state) => state.bargeCostUtilizationData,
  routes: (state) => state.routes
}

const mutations = {
  SET_BARGE_COST_UTILIZATION_DATA: (state, payload) => {
    state.bargeCostUtilizationData = payload
  },
  SET_ROUTES: (state, payload) => {
    state.routes = payload
  },
  SET_LAST_REQUEST_ID: (state, payload) => {
    state.lastRequestId = payload
  }
}

const actions = {
  async fetchBargeCostUtilization({ commit, state }, payload) {
    try {
      if (payload && typeof payload._requestId === 'number') {
        commit('SET_LAST_REQUEST_ID', payload._requestId)
      }

      const { data } = await api.getBargeCostUtilization(payload)

      // Ignore stale responses if a newer request has been made.
      if (payload && typeof payload._requestId === 'number' && payload._requestId < state.lastRequestId) {
        return
      }

      if (data.error) {
        commit('SET_BARGE_COST_UTILIZATION_DATA', null)
        return
      }

      commit('SET_BARGE_COST_UTILIZATION_DATA', data)
    } catch (err) {
      throw err
    }
  },
  async fetchRoutes({ commit }) {
    try {
      const { data } = await api.getBargeCostUtilRoutes()

      if (data.error) {
        commit('SET_ROUTES', [])
        return
      }

      commit('SET_ROUTES', data)
    } catch (err) {
      throw err
    }
  }
}

export default { namespaced, state, getters, mutations, actions }